import { render, staticRenderFns } from "./planMantainOrder.vue?vue&type=template&id=8b4be166&scoped=true"
import script from "./planMantainOrder.vue?vue&type=script&lang=js"
export * from "./planMantainOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4be166",
  null
  
)

export default component.exports